import { render, staticRenderFns } from "./Classifieds.vue?vue&type=template&id=00a7e386&"
import script from "./Classifieds.vue?vue&type=script&lang=ts&"
export * from "./Classifieds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports